import { ELECTRON_EVENTS } from '~/main/namespace';

import type { Action, Store } from '@reduxjs/toolkit';

export function replayActionRenderer(store: Store) {
  window.ipcRenderer?.on(ELECTRON_EVENTS.REDUX_ACTION, (_: Event, payload: Action) => {
    store.dispatch(payload);
  });
}
